import { ChannelManagerListCriteria } from "../objects/channelManagerListCriteria";

export const EMPTY_SUB_MODULE_LIST_CRITERIA: ChannelManagerListCriteria = { order_by: 'name', search: '', order: 'asc', page: 1, page_size: 10 }